import React from 'react';
import { Link, graphql, StaticQuery } from "gatsby";

export default function HeroNavBarWithData(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              loginLink
            }
          }
        }
      `}
      render={data => <MainNavBar data={data} {...props} />}
    />
  )
}

const MainNavBar = ({ data }) => {
  const navLinkClass = 'f5 fw4 dim no-underline gray dib-ns pv2 ph3';
  const navButtonClass =
    'f6 fw4 dim pointer no-underline tc dib ml2 pv2 ph3 mt2 ba b--light-red light-red';

  return (
    <header className="bb b--light-gray">
      <nav className="db dt-l w-100 mw8 center">
        <div className="db dtc-l w4 center v-mid pa3 tc">
          <Link to="/" className="pa1 pointer">
            <img src="/img/header-logo.png" className=" mb0" alt="O3" />
          </Link>
        </div>
        <div className="db dtc-l v-mid tr-l tc pa3-l">
          <Link to="/outreach/features/" className={navLinkClass}>
            Features
          </Link>
          <Link to="/outreach/pricing/" className={navLinkClass}>
            Pricing
          </Link>
          <Link to="/blog/" className={navLinkClass}>
            Blog
          </Link>
          <a href={data.site.siteMetadata.loginLink} className={navLinkClass}>
            Log In
          </a>
          <Link to="/request-a-demo/" className={navButtonClass}>
            Request a Demo
          </Link>
        </div>
      </nav>
    </header>
  );
};
